import React from 'react';
import { NodeResizer } from 'reactflow';
import BaseScadaNode from './BaseScadaNode';

function hexToRgba(hex, alpha) {
    const h = hex.replace('#', '');
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return `rgba(${r},${g},${b},${alpha})`;
}

export default function CircleShapeNode(props) {
    const { data, selected } = props;
    const config = data?.config || {};
    const fillHex = config.fill || '#334155';
    const fillOpacity = config.fill_opacity ?? 0.5;
    const fill = hexToRgba(fillHex, fillOpacity);
    return (
        <BaseScadaNode {...props}>
            {data?.isEditMode && (
                <NodeResizer isVisible={selected} minWidth={20} minHeight={20}
                    lineStyle={{ border: '1.5px solid #4F46E5' }}
                    handleStyle={{ width: 8, height: 8, background: '#4F46E5', border: '1px solid #818CF8', borderRadius: 2 }} />
            )}
            <div style={{
                width: '100%',
                height: '100%',
                background: fill,
                border: `${config.border_width || 2}px solid ${config.border_color || '#475569'}`,
                borderRadius: '50%',
                boxSizing: 'border-box',
            }} />
        </BaseScadaNode>
    );
}
